import { useImpersonationStore } from '@/store/impersonation'

export function useOrgScopedQueryKey(): string {
  return useImpersonationStore((state) => state.impersonatedOrgId ?? 'self')
}
